const IndiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111618)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#FF9811"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#6DA544"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#0052B4"
      />
      <path
        d="M20.0002 24.347C22.4014 24.347 24.348 22.4004 24.348 19.9992C24.348 17.5979 22.4014 15.6514 20.0002 15.6514C17.5989 15.6514 15.6523 17.5979 15.6523 19.9992C15.6523 22.4004 17.5989 24.347 20.0002 24.347Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 14.6338L21.3412 17.6758L24.6462 17.3164L22.6824 19.9989L24.6462 22.6815L21.3412 22.3221L19.9998 25.3641L18.6585 22.3221L15.3535 22.6814L17.3173 19.9989L15.3535 17.3164L18.6585 17.6758L19.9998 14.6338Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111618">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IndiaSvg;
